import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";
import { PegGraphRes } from "../patients/index.type";

const useFetchPegGraph = (billingCycleId: string) => {
  const [pegGraph, setPegGraph] = React.useState<PegGraphRes | null>(null);

  const { loading: pegGraphLoading, makeApiCall } = useApi({
    url: `/rtm/patient-dashboard/pdf/v3/peg-chart/${billingCycleId}`,
    method: "GET",
  });

  const getPegGraphData = async () => {
    if (!billingCycleId) return;

    const { response, error } = await makeApiCall<undefined, PegGraphRes>();

    if (response?.status === "success") {
      setPegGraph(response);
    } else {
      setPegGraph(null);
    }

    if (error) {
      toast.error(error.msg);
    }
  };

  return {
    pegGraph,
    getPegGraphData,
    pegGraphLoading,
  };
};

export default useFetchPegGraph;
